import { Flex, Text, Link, VStack, Button } from '@chakra-ui/react'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import FreePlanGraphic from '../../../graphics/FreePlanGraphic'
import { colors } from '../../../ui-kit'
import type { FeaturesEnum } from '../../../utils/features'
import { FeatureNameMapping } from '../../../utils/features'
interface Props {
  feature: FeaturesEnum
}
const CustomPlanCTA = ({ feature }: Props): React.ReactElement => {
  const { t } = useTranslation()
  const featureText = FeatureNameMapping[feature]
  const history = useHistory();
  return (
    <Flex direction="column" align="center" justify="center">
      <FreePlanGraphic width="260px" height="200px" marginTop="8em" />
      <Trans t={t} i18nKey="custom_plan_info">
        <VStack>
          <Text
            marginTop="1.25em"
            fontSize="1em"
            fontWeight="semibold"
            color="appBattleshipGrey"
            align="center"
          >
            {{ featureText }} feature is not available in your current plan.
          </Text>
          <Text
            marginTop="1.25em"
            fontSize="1em"
            fontWeight="semibold"
            color="appBattleshipGrey"
          >
            <Link isExternal href="https://imagekit.io/contact-us/">
              Contact sales
            </Link>{' '}
            to enable this feature.
          </Text>
        </VStack>
      </Trans>
      {window?.isMediaLibraryWidget && (
        <Trans t={t} i18nKey="go_to_previous_page">
          <Text
            marginTop="1.25em"
            fontSize="1em"
            fontWeight="semibold"
            color="appBattleshipGrey"
            align="center"
          >
            Go to
            <Button
              variant={'link'}
              color={colors.appClearBlue}
              onClick={() => history?.goBack()}
              fontWeight={500}
            >
              previous
            </Button>
            page.
          </Text>
        </Trans>
      )}
    </Flex>
  )
}

export default CustomPlanCTA
